export default "__VITE_PUBLIC_ASSET__05bc8f0e__"